import {
    noConversationsSelected,
    oneConversationSelected,
    someConversationsSelected,
    everythingSelectedTab,
} from './getItemsOrConversationsSelectedText.locstring.json';
import { everythingSelected } from 'owa-locstrings/lib/strings/everythingselected.locstring.json';
import { everythingSelectedOther } from 'owa-locstrings/lib/strings/everythingselectedother.locstring.json';
import { everythingSelectedFocused } from 'owa-locstrings/lib/strings/everythingselectedfocused.locstring.json';
import { everythingSelectedSearch } from 'owa-locstrings/lib/strings/everythingselectedsearch.locstring.json';
import {
    noItemsSelected,
    oneItemSelected,
    someItemsSelected,
} from 'owa-locstrings/lib/strings/someitemsselected.locstring.json';
import loc, { format } from 'owa-localize';
import listViewStore from '../store/Store';
import getIsEverythingSelectedInTable from './getIsEverythingSelectedInTable';
import isItemPartOperation from './isItemPartOperation';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import getFocusedFilterForTable from '../utils/getFocusedFilterForTable';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import {
    getInboxClassificationFilterForTable,
    TableQueryType,
    MailFolderTableQuery,
} from 'owa-mail-list-store';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';
import folderStore, { getEffectiveFolderDisplayName } from 'owa-folders';

export default function getItemsOrConversationsSelectedText(tableViewId: string): string {
    const tableView = listViewStore.tableViews.get(tableViewId);
    const focusedFilter = getFocusedFilterForTable(tableView);
    const inboxClassificationFilter = getInboxClassificationFilterForTable(tableViewId);
    const {
        tableQuery,
        isInVirtualSelectAllMode,
        virtualSelectAllExclusionList,
        totalRowsInView,
        selectedRowKeys,
    } = tableView;

    // User is in select all mode
    if (getIsEverythingSelectedInTable(tableView)) {
        // User is in select all mode in focused/other table
        if (isInboxPlusEnabled() && folderNameToId('inbox') === tableQuery.folderId) {
            const displayProperties = getInboxPlusPivotDisplayProperties(inboxClassificationFilter);
            return format(loc(everythingSelectedTab), displayProperties.displayText);
        } else if (focusedFilter !== FocusedViewFilter.None) {
            return focusedFilter === FocusedViewFilter.Focused
                ? loc(everythingSelectedFocused)
                : loc(everythingSelectedOther);
            // User is in search results
        } else if (tableQuery.type == TableQueryType.Search) {
            return loc(everythingSelectedSearch);
            // User is in favorited category
        } else if ((tableQuery as MailFolderTableQuery).viewFilter === 'UserCategory') {
            return format(
                loc(everythingSelected),
                (tableQuery as MailFolderTableQuery).categoryName
            );
        }
        // Everything in folder or favorited persona is selected
        const folder = folderStore.folderTable.get(tableQuery.folderId);
        return format(loc(everythingSelected), getEffectiveFolderDisplayName(folder));
    }

    // Only some rows are selected:

    // User selected all but then deselected some rows, return total item count - number of deselected items
    else if (isInVirtualSelectAllMode && virtualSelectAllExclusionList.length > 0) {
        return format(
            loc(someItemsSelected),
            totalRowsInView - virtualSelectAllExclusionList.length
        );
    }

    // User has selected a specific number of rows or row parts
    const numSelections = isItemPartOperation()
        ? listViewStore.expandedConversationViewState.selectedNodeIds.length
        : selectedRowKeys.size;
    if (tableQuery.listViewType == ReactListViewType.Message || isItemPartOperation()) {
        // Designate string for rows
        if (numSelections === 0) {
            return loc(noItemsSelected);
        } else if (numSelections === 1) {
            return loc(oneItemSelected);
        }
        return format(loc(someItemsSelected), numSelections);
    }
    // Designate string for conversations
    if (numSelections === 0) {
        return loc(noConversationsSelected);
    } else if (numSelections === 1) {
        return loc(oneConversationSelected);
    }
    return format(loc(someConversationsSelected), numSelections);
}
